module.exports = __webpack_public_path__ + "img/resource05.4c475ac3.png";